<template>
<ul class="nav-section nav flex-column order-0" :class="{ minimized: isMinimized }">
	<li class="nav-item">
		<router-link
			class="nav-link"
			:class="{active: ['stations', ...stationChildrenPages].includes($route.name)}"
			:to="{ name: 'stations' }"
		>
			<span class="feather align-text-bottom">
				<menu-icon name="station" color="currentColor" :edge-size="iconSize + 4" />
			</span>
			<span class="nav-link-text ms-1">СКЗ</span>
		</router-link>
	</li>
	<li class="nav-item">
		<router-link
			class="nav-link"
			:class="{active: ['posts', ...postChildrenPages,].includes($route.name)}"
			:to="{ name: 'posts' }"
		>
			<menu-icon name="post" color="currentColor" :edge-size="iconSize + 4" />
			<span class="nav-link-text ms-1">КВП</span>
		</router-link>
	</li>
	<li class="nav-item">
		<router-link
			class="nav-link"
			:class="{active: $route.name == 'map'}"
			:to="{ name: 'map' }"
		>
			<span class="feather align-text-bottom">
				<menu-icon name="map" color="currentColor" :edge-size="iconSize + 4" />
			</span>
			<span class="nav-link-text ms-1">Мапа</span>
		</router-link>
	</li>
	<li class="nav-item">
		<router-link
			class="nav-link"
			:class="{active: $route.name == 'relation_graph'}"
			:to="{ name: 'relation_graph' }"
		>
			<menu-icon name="relationGraph" color="currentColor" :edge-size="iconSize + 4" />
			<span class="nav-link-text ms-1">Схема</span>
		</router-link>
	</li>
	<li class="nav-item">
		<router-link
			class="nav-link"
			:class="{active: alertsChildrenPages.includes($route.name)}"
			:to="{ name: 'alerts_table' }"
		>
			<span class="feather align-text-bottom">
				<menu-icon name="alerts" color="currentColor" :edge-size="iconSize + 4" />
			</span>
			<span class="nav-link-text ms-1">Сповіщення</span>
		</router-link>
	</li>
	<li class="nav-item">
		<router-link
			class="nav-link"
			:class="{active: $route.name == 'reports'}"
			:to="{ name: 'reports' }"
		>
			<span class="feather align-text-bottom">
				<menu-icon name="report" color="currentColor" :edge-size="iconSize + 4" />
			</span>
			<span class="nav-link-text ms-1">Звіти</span>
		</router-link>
	</li>
	<li	class="nav-item">
		<router-link
			class="nav-link"
			:class="{'disabled': !accountStore.permissions.includes('manage_users'),
				active: ['user','users'].includes($route.name)}"
			:to="{ name: 'users' }"
		>
			<span class="feather align-text-bottom">
				<menu-icon name="users" color="currentColor" :edge-size="iconSize + 4" />
			</span>
			<span class="nav-link-text ms-1">Користувачі</span>
		</router-link>
	</li>
	<li	class="nav-item">
		<router-link
			class="nav-link"
			:class="{'disabled': !accountStore.permissions.includes('manage_organizations'),
				active: ['organization','organizations'].includes($route.name)}"
			:to="accountStore.isPrimary ? organizationsTableRoute : organizationSelfUpdateRoute"
			@click="isUpdateOrganizationPopupOpen = true"
		>
			<span class="feather align-text-bottom">
				<menu-icon name="organization" color="currentColor" :edgeSize="iconSize + 4" />
			</span>
			<span class="nav-link-text">{{ accountStore.isPrimary ? "Організації" : "Організація" }}</span>
		</router-link>
	</li>
</ul>

<!-- Adaptive menu section -->
<ul class="nav-section nav flex-column order-1" :class="{ minimized: isMinimized }">
	<hr v-if="!isMinimized || isTabsSectionVisible" class=" m-0 mt-2">
	<!-- Checklist: hidden in minimized mode -->
	<span v-if="!isMinimized && customNav.getType === SECTION_TYPES.checklist">
		<!-- Iterate collections -->
		<template v-for="collection in customNav.collections" :key="collection">
			<!-- If only one checkbox in collection - show without dropdown -->
			<li
				v-if="customNav.linesArray.filter((line) => line.collection == collection).length == 1"
				class="nav-item form-check form-switch mt-1 ps-6 ms-2"
			>
				<!-- Prevent history routing errors -->
				<span v-if="Object.hasOwn(customNav.linesArray.filter((line) => line.collection == collection)[0], 'id')
					&& Object.hasOwn(customNav.linesArray.filter((line) => line.collection == collection)[0], 'name')
					&& Object.hasOwn(customNav.linesArray.filter((line) => line.collection == collection)[0], 'isChecked')
				">
					<input
						class="form-check-input me-1"
						type="checkbox"
						role="switch"
						:name="customNav.linesArray.filter((line) => line.collection == collection)[0].id"
						:id="customNav.linesArray.filter((line) => line.collection == collection)[0].id"
						v-model="customNav.linesArray.filter((line) => line.collection == collection)[0].isChecked"
						@change="customNav.linesArray.filter((line) => line.collection == collection)[0].eventHandler()"
					>
					<label class="form-check-label" :for="customNav.linesArray.filter((line) => line.collection == collection)[0].id">
						{{ customNav.linesArray.filter((line) => line.collection == collection)[0].name }}
					</label>
				</span>
			</li>
			<!-- else show in dropdown spoiler -->
			<drop-down-spoiler v-else
				size="s"
			>
				<template v-slot:title>
					<span class="nav-item form-check form-switch m-0 p-0">{{ collection }}</span>
				</template>
				<template v-slot:body>
					<li
						class="nav-item form-check form-switch mt-1 ps-6 ms-2"
						v-for="line in customNav.linesArray.filter((line) => line.collection == collection)"
						:key="line.id"
					>
						<!-- Prevent history routing errors -->
						<span v-if="Object.hasOwn(line, 'id')
							&& Object.hasOwn(line, 'name')
							&& Object.hasOwn(line, 'isChecked')
						">
							<input
								class="form-check-input me-1"
								type="checkbox"
								role="switch"
								:name="line.id"
								:id="line.id"
								v-model="line.isChecked"
								@change="line.eventHandler()"
							>
							<label class="form-check-label" :for="line.id">
								{{ line.name }}
							</label>
						</span>
					</li>
				</template>
			</drop-down-spoiler>
		</template>
	</span>

	<!-- Tabs custom navigation. Shown both in open and minimized (icon-only) modes.
	Need check $route.name for prevent error 'Missing required param "id"'on route from station to any other page. -->
	<span
		v-if="isTabsSectionVisible"
		class="mt-2"
	>
		<li
			v-for="(line, i) in customNav.linesArray"
			:key="i"
			class="nav-item"
		>
			<router-link
				class="nav-link px-1 mx-0 my-1 py-1"
				:class="{
					active: $route.name == line.id,
					'disabled': line.meta?.permission ?
						!accountStore.permissions.includes(line.meta.permission)
						: false
				}"
				:to="{ name: line.id }" 
			>
				<span class="feather align-text-bottom">
					<menu-icon :name="line.id" color="currentColor" :edge-size="iconSize" />
				</span>
				<span class="nav-link-text">
					{{ line.name }}
					<sup v-if="line.meta && line.meta.sup !== undefined"
						class="text-success"
					>
						{{ line.meta.sup }}
					</sup>
				</span>
			</router-link>
		</li>
	</span>
</ul>

<!-- Minimized strip: single button to expand the menu -->
<ul v-if="isMinimized && customNav.getType === SECTION_TYPES.checklist" class="nav-section nav flex-column order-1">
	<li class="nav-item expand-menu-item">
		<button
			type="button"
			class="expand-menu-btn"
			aria-label="Розгорнути меню"
			@click="$emit('expand')"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				:width="iconSize"
				:height="iconSize"
				fill="currentColor"
				class="bi bi-chevron-right"
				viewBox="0 0 16 16"
			>
				<path
					fill-rule="evenodd"
					d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
				/>
			</svg>
		</button>
	</li>
</ul>

<!-- Menu footer -->
<ul class="nav-section nav order-2 flex-column mt-auto" :class="{ minimized: isMinimized }">
	<li v-if="!isMinimized && accountStore.account.role === 'admin'"
		class="version fw-light fst-italic font-monospace ps-2 align-items-end mt-auto mb-1"
	>
		Версія {{ APP_VERSION }}
	</li>
	<hr class="my-2">

	<li class="nav-item">
		<button
			class="nav-link"
			@click="userSelfUpdate"
		>
			<span class="feather align-text-bottom">
				<menu-icon name="account" color="currentColor" :edgeSize="iconSize + 4" />
			</span>
			<span class="nav-link-text">{{ accountStore.account.login }}</span>
		</button>
	</li>
	<li class="nav-item">
		<button
			class="nav-link"
			@click="signout"
		>
			<span class="feather align-text-bottom">
				<menu-icon name="signout" color="currentColor" :edgeSize="iconSize + 4" class="text-danger" />
			</span>
			<span class="nav-link-text">Вийти</span>
		</button>
	</li>
</ul>
</template>
	
	
<script>
import { inject } from 'vue'
import { APP_VERSION } from '@/app.conf.js'
import { useAccontStore } from '@/stores/AccountStore.js'
import { SECTION_TYPES } from '@/customNavSection.js'
import MenuIcon from '@/components/Icons/MenuIcon.vue'
import DropDownSpoiler from '@/components/DropDownSpoiler.vue'


export default {
	inject: [ 'stationSvgPath', ],

	components: {
		MenuIcon,
		DropDownSpoiler,
	},

	setup() {
		const customNav = inject('customNavSection')
		const accountStore = useAccontStore()
		const iconSize = 16

		return {
			customNav,
			accountStore,
			APP_VERSION,
			SECTION_TYPES,
			iconSize,
		}
	},

	props: {
		displayMode: {
			type: String,
			required: false,
			default: 'open',
			validator: (value) => ['hidden', 'minimized', 'open'].includes(value),
		},
	},

	emits: {
		signout: null,
		expand: null,
	},

	data() {
		return {
			isUpdateOrganizationPopupOpen: false,
			isUpdateUserPopupOpen: false,
		}
	},

	created() {},

	mounted() {},

	methods: {
		signout() {
			this.$emit('signout')
		},

		userSelfUpdate() {
			const id = String(this.accountStore.userId)
			this.$router.push({ name: 'user', params: { id } })
		},
	},

	computed: {
		isMinimized() {
			return this.displayMode === 'minimized'
		},

		isTabsSectionVisible() {
			return this.customNav.getType === SECTION_TYPES.tabs
				&& [
					...this.stationChildrenPages,
					...this.postChildrenPages,
					...this.alertsChildrenPages,
				].includes(this.$route.name)
		},

		organizationsTableRoute() {
			return { name: 'organizations'}
		},

		organizationSelfUpdateRoute() {
			const id = String(this.accountStore.organization._id)
			//this.$router.push({ name: 'organization', params: { id } })
			return { name: 'organization', params: { id } }
		},

		stationChildrenPages() {
			return [
				'station_control',
				'station_alerts',
				'electric_meter_control',
				'station_breaker',
				'station_protection',
				'station_manage',
				'station_view_report',
				'station_security',
				'station_lightnings',
				'station_download_report',
				'station_analytic',
				'station_log',
				'station_settings',
				'station_calibration',
				'station_passport',
				'station_chart',
				'station_passport_history',
				'station_passport_table',
				'stations_passport_history',
			]
		},

		postChildrenPages() {
			return [
				'post_control',
				'post_view_report',
				'post_log',
				'post_settings',
				'post_passport',
				'post_passport_history',
				'post_passport_table',
				'posts_passport_history',
			]
		},

		alertsChildrenPages() {
			return [
				'events_table',
				'alerts_table',
				'station_subscriptions',
				'post_subscriptions',
			]
		},
	},
}
</script>


<style scoped>
.feather {
	width: v-bind(iconSize);
	height: v-bind(iconSize);
}

.nav-link {
	width: 100%;
	display: inline-flex;
	align-items: center;
	gap: 0.25rem;

	font-weight: 500;
	color: #333;
	white-space: nowrap;
}

.nav-link .feather {
	margin-right: 4px;
	/* color: #727272; */
}

.nav-link.active {
	/* color: #2470dc; */
	background-color: #c6c7c8;
	border-radius: 0.25rem;
}

.nav-link.disabled {
	color: rgba(0, 0, 0, 0.3);
}

.nav-link:hover .feather,
.nav-link.active .feather {
	color: inherit;
}

.nav-section {
	width: 100%;
}

/* Minimized (icon-only) menu strip */
.nav-section.minimized .nav-item {
	padding-left: 0 !important;
	padding-right: 0 !important;
}

.nav-section.minimized .nav-link {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	padding-left: 0 !important;
	padding-right: 0 !important;
}

.nav-section.minimized .nav-link .feather {
	margin-right: 0;
}

/* In minimized mode the label becomes a hover tooltip next to the icon */
.nav-section.minimized .nav-link-text {
	position: absolute;
	left: 100%;
	top: 50%;
	transform: translateY(-50%);
	margin-left: 0.5rem;
	padding: 0.25rem 0.5rem;
	background-color: #333;
	color: #fff;
	font-size: 0.8125rem;
	line-height: 1.2;
	border-radius: 0.25rem;
	white-space: nowrap;
	pointer-events: none;
	opacity: 0;
	visibility: hidden;
	transition: opacity 0.12s ease-in-out;
	z-index: 1050;
}

.nav-section.minimized .nav-link:hover .nav-link-text {
	opacity: 1;
	visibility: visible;
}

/* Button that expands the menu from the minimized strip */
.expand-menu-item {
	display: flex;
	justify-content: center;
	margin-top: 0.5rem;
}

.expand-menu-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 2rem;
	height: 2rem;
	padding: 0;
	border: none;
	background: transparent;
	color: #727272;
	border-radius: 0.25rem;
	cursor: pointer;
}

.expand-menu-btn:hover {
	background-color: #c6c7c8;
	color: inherit;
}

.version {
	font-size: .75rem;
}

/* Custom nav slider */
.form-check-input:checked {
	background-color: rgba(33, 37, 41, 0.5);
	border-color: rgba(33, 37, 41, 0.9);
}
</style>
